export default __webpack_public_path__ + "e32a93c85cb7b6d417bfbebcaa6a47b0.png";